"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const ReplacesEnum_1 = require("../ReplacesEnum");
exports.Common = Object.freeze({
    EXTENSION_NAME: 'Omnito Meeting Booker: Programación sin complicaciones',
    EXTENSION_SHORT_NAME: 'Omnito Inbox',
    EXTENSION_DESCRIPTION: '¡Simplifica la programación! Con un clic conecta tu calendario, define tu disponibilidad y envía invitaciones para asegurarte de no tener citas dobles.',
    EXTENSION_BUTTON_TOOLTIP: 'Insertar Omnito Meeting Booker',
    AUTHORIZATION_SERVER_ONE: 'Omnito',
    AUTHORIZATION_SERVER_SALESFORCE: 'Omnito para Salesforce (CEP)',
    AUTHORIZATION_SERVER_SALESFORCE_PRODUCTION: 'Producción',
    AUTHORIZATION_SERVER_SALESFORCE_SANDBOX: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_SUMO1_LOGIN_TITLE: 'Omnito',
    ACTIVE_TAB_SIDEBAR_SALESFORCE_LOGIN_TITLE: 'Omnito para Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_BUTTON: 'Iniciar sesión',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_GOOGLE_BUTTON: 'Iniciar sesión con Google',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_MICROSOFT_BUTTON: 'Iniciar sesión con Microsoft',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_BUTTON: 'Iniciar sesión con Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_PRODUCTION_BUTTON: 'Producción',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_SANDBOX_BUTTON: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_TEXT: '¿No tienes cuenta?',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_LINK: 'Regístrate',
    ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON: 'Crear reunión',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN: 'Bienvenido, has iniciado sesión.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN_CREATE_MEETING_BUTTON: 'Haz clic en Crear reunión para añadir franjas horarias a tu correo.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_1: "1. Abre <a target='_blank' class='text-blue-100 no-underline' href='https://mail.google.com'>Gmail.com</a> o <a target='_blank' class='text-blue-100 no-underline' href='https://outlook.live.com'>Outlook.live.com</a> y crea un nuevo correo",
    GMAIL_URL: 'gmail.com',
    OUTLOOK_URL: 'outlook.live.com',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_2: '2. Haz clic en el ícono de Meeting Booker',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_3: '3. Make booking faster. Connect your contacts to speed up booking.',
    ACTIVE_TAB_SIDEBAR_ALLOW_CONTACTS_ACCESS_BUTTON: 'Allow access',
    SCHEDULER_CONNECT_CONTACTS_BANNER_TITLE: 'Make booking faster',
    SCHEDULER_CONNECT_CONTACTS_BANNER_DESCRIPTION: 'Connect your Google Contacts to quickly find people and autofill meeting details.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON: 'Cerrar sesión',
    ACTIVE_TAB_SETTINGS_LOGOUT_BUTTON: 'Cerrar sesión',
    SCHEDULER_DEFAULT_WORKSPACE_LABEL: 'Espacio de trabajo por defecto',
    SCHEDULER_WORKSPACE_LABEL: 'Espacio de trabajo',
    SCHEDULER_WORKSPACE_TOOLTIP: 'La lista de servicios y anfitriones se actualizará según el espacio de trabajo seleccionado',
    SCHEDULER_SETTINGS_DEFAULT_PROCESS_LABEL: 'Proceso por defecto',
    SCHEDULER_SETTINGS_DEFAULT_HOST_LABEL: 'Anfitrión por defecto',
    SCHEDULER_SETTINGS_HOST_ME_LABEL: 'Yo',
    SCHEDULER_SETTINGS_HOST_NONE_LABEL: 'Ninguno',
    SCHEDULER_SETTINGS_BUTTON: 'Configuraciones',
    SCHEDULER_SETTINGS_TOOLTIP: 'Configuraciones',
    SCHEDULER_MEETING_NAME_LABEL: 'Nombre de la reunión',
    SCHEDULER_APPOINTMENT_TITLE_LABEL: 'Título / Tipo de cita',
    SCHEDULER_APPOINTMENT_TYPES_LABEL: 'Tipos de cita',
    SCHEDULER_APPOINTMENT_TYPES_PLACEHOLDER: 'Seleccionar tipos de cita',
    SCHEDULER_APPOINTMENT_TYPES_SEARCH_PLACEHOLDER: 'Buscar',
    SCHEDULER_APPOINTMENT_TYPES_MAX_WARNING: `Se pueden seleccionar un máximo de ${ReplacesEnum_1.ReplacesDetailEnum.MAX}.`,
    SCHEDULER_APPOINTMENT_TITLE_ONLY_LABEL: 'Título de la cita',
    SCHEDULER_APPOINTMENT_TITLE_ONLY_PLACEHOLDER: 'Ingrese el título de la cita',
    SCHEDULER_TITLE_PLACEHOLDER: 'Introduce un nombre',
    SCHEDULER_MEETING_TYPE_LABEL: 'Meeting Type',
    SCHEDULER_MEETING_TYPES_LABEL: 'Meeting Types',
    SCHEDULER_TEMPLATE_PLACEHOLDER: 'Seleccionar',
    SCHEDULER_DURATION_LABEL: 'Duración',
    SCHEDULER_TOTAL_DURATION_LABEL: 'Duración total',
    SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL: 'minutos',
    SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL: 'horas',
    SCHEDULER_DURATION_DIMENSION_MINUTES_SHORT_LABEL: 'min',
    SCHEDULER_DURATION_DIMENSION_HOURS_SHORT_LABEL: 'h',
    SCHEDULER_DURATION: 'duración',
    SCHEDULER_BUFFER: 'margen',
    SCHEDULER_BUFFER_TIME_NONE_LABEL: 'Ninguno',
    SCHEDULER_BUFFER_TIME_MIN5_LABEL: '5 min',
    SCHEDULER_BUFFER_TIME_MIN10_LABEL: '10 min',
    SCHEDULER_BUFFER_TIME_MIN15_LABEL: '15 min',
    SCHEDULER_BUFFER_TIME_MIN20_LABEL: '20 min',
    SCHEDULER_BUFFER_TIME_MIN25_LABEL: '25 min',
    SCHEDULER_BUFFER_TIME_MIN30_LABEL: '30 min',
    SCHEDULER_BUFFER_TIME_MIN35_LABEL: '35 min',
    SCHEDULER_BUFFER_TIME_MIN40_LABEL: '40 min',
    SCHEDULER_BUFFER_TIME_MIN45_LABEL: '45 min',
    SCHEDULER_BUFFER_TIME_MIN50_LABEL: '50 min',
    SCHEDULER_BUFFER_TIME_MIN55_LABEL: '55 min',
    SCHEDULER_BUFFER_TIME_MIN60_LABEL: '60 min',
    SCHEDULER_BUFFER_LABEL: 'Margen',
    SCHEDULER_BUFFER_TOOLTIP: 'Bloquea el calendario del anfitrión antes y/o después de esta reunión por esta duración. Los tiempos de margen suelen usarse para preparación, retroalimentación o desplazamiento en reuniones presenciales.',
    SCHEDULER_BUFFER_BEFORE_LABEL: 'Antes',
    SCHEDULER_BUFFER_AFTER_LABEL: 'Después',
    SCHEDULER_LOCATION_LABEL: 'Ubicación',
    SCHEDULER_LOCATION_VIDEO_CONFERENCE: 'Videoconferencia',
    SCHEDULER_LOCATION_IN_PERSON: 'Presencial',
    SCHEDULER_LOCATION_PHONE: 'Teléfono',
    SCHEDULER_LOCATION_PHONE_HOST_PHONE: 'Anfitrión',
    SCHEDULER_LOCATION_PHONE_INVITEE_PHONE: 'Invitado',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE: 'Personalizado',
    SCHEDULER_LOCATION_INTEGRATION_ENABLED_LABEL: 'Incluir detalles de videoconferencia',
    SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL: 'Zoom',
    SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL: 'Google Meet',
    SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL: 'Microsoft Teams',
    SCHEDULER_LOCATION_PHYSICAL_ADDRESS_PLACEHOLDER: 'Elegir dirección',
    SCHEDULER_LOCATION_ROOM_PLACEHOLDER: 'Sala',
    SCHEDULER_LOCATION_RESOURCES_PLACEHOLDER: 'Recursos',
    SCHEDULER_LOCATION_CUSTOM_ADDRESS_PLACEHOLDER: 'Introduce dirección personalizada',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PLACEHOLDER: 'Introduce número de teléfono',
    SCHEDULER_LOCATION_IN_PERSON_LOCATION: 'Ubicaciones de la organización',
    SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS: 'Dirección personalizada',
    SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION: 'Ubicación del invitado',
    SCHEDULER_AVAILABILITY_LABEL: 'Disponibilidad',
    SCHEDULER_AVAILABILITY_TOOLTIP: 'El modo abierto ofrecerá la mayor cantidad de fechas/horas disponibles al invitado principal. Las opciones adicionales (personalizado, ventana móvil, rango de fechas) permiten limitar las franjas disponibles.',
    SCHEDULER_AVAILABILITY_OPEN: 'Abierto',
    SCHEDULER_AVAILABILITY_CUSTOM: 'Personalizado',
    SCHEDULER_AVAILABILITY_ROLLING: 'Móvil',
    SCHEDULER_AVAILABILITY_RANGE: 'Rango',
    SCHEDULER_AVAILABILITY_OPEN_DESCRIPTION: 'Esta reunión puede programarse en cualquier fecha/hora disponible, a partir de cuando el asistente haga clic en el enlace de invitación.',
    SCHEDULER_AVAILABILITY_CUSTOM_DESCRIPTION: 'En el calendario puedes definir tu disponibilidad personalizada para esta invitación. Solo se ofrecerán los horarios que marques como disponibles.',
    SCHEDULER_AVAILABILITY_ROLLING_DESCRIPTION: 'Los asistentes verán horarios disponibles durante un período que comienza cuando hacen clic en el enlace de invitación.',
    SCHEDULER_AVAILABILITY_ROLLING_WINDOW_LABEL: 'Ventana (días)',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_LABEL: 'Expira',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_PLACEHOLDER: 'Nunca',
    SCHEDULER_AVAILABILITY_RANGE_DESCRIPTION: 'Selecciona un rango de fechas de disponibilidad para ofrecer.',
    SCHEDULER_AVAILABILITY_RANGE_START_LABEL: 'Inicio',
    SCHEDULER_AVAILABILITY_RANGE_START_DATE_PLACEHOLDER: 'Fecha de inicio',
    SCHEDULER_AVAILABILITY_RANGE_START_TIME_PLACEHOLDER: 'Hora de inicio',
    SCHEDULER_AVAILABILITY_RANGE_END_LABEL: 'Fin',
    SCHEDULER_AVAILABILITY_RANGE_END_DATE_PLACEHOLDER: 'Fecha de fin',
    SCHEDULER_AVAILABILITY_RANGE_END_TIME_PLACEHOLDER: 'Hora de fin',
    SCHEDULER_LIMIT_LABEL: 'Límite',
    SCHEDULER_LIMIT_TOOLTIP: 'Limita el número de citas que pueden reservarse con esta invitación/enlace. Una vez alcanzado el límite, la invitación/enlace expirará automáticamente.',
    SCHEDULER_LIMIT_LIMIT1_LABEL: '1',
    SCHEDULER_LIMIT_LIMIT2_LABEL: '2',
    SCHEDULER_LIMIT_LIMIT3_LABEL: '3',
    SCHEDULER_LIMIT_LIMIT4_LABEL: '4',
    SCHEDULER_LIMIT_LIMIT5_LABEL: '5',
    SCHEDULER_LIMIT_LIMIT6_LABEL: '6',
    SCHEDULER_LIMIT_LIMIT7_LABEL: '7',
    SCHEDULER_LIMIT_LIMIT8_LABEL: '8',
    SCHEDULER_LIMIT_LIMIT9_LABEL: '9',
    SCHEDULER_LIMIT_LIMIT10_LABEL: '10',
    SCHEDULER_LIMIT_UNLIMITED_LABEL: 'Ilimitado',
    SCHEDULER_HOST_LABEL: 'Anfitrión',
    SCHEDULER_HOST_PLACEHOLDER: 'Agregar anfitrión',
    SCHEDULER_ADD_GUEST_LABEL: 'Agregar asistentes',
    SCHEDULER_ADD_GUEST_PLACEHOLDER: 'Buscar por nombre o correo',
    SCHEDULER_MAIN_GUEST_LABEL: 'Invitado',
    SCHEDULER_NOTE_LABEL: 'Nota para invitado y asistentes',
    SCHEDULER_MAIN_GUEST_TOOLTIP: 'Si defines al invitado, haz clic en "Insertar franjas y cerrar" para añadir horarios al correo. De lo contrario, haz clic en "Copiar enlace y cerrar" para enviarlo a cualquiera, y el invitado podrá identificarse al reservar.',
    SCHEDULER_MAIN_GUEST_PLACEHOLDER: 'Buscar por nombre o correo',
    SCHEDULER_GUESTS_LABEL: 'Asistentes',
    SCHEDULER_DESCRIPTION_LABEL: 'Nota del anfitrión',
    SCHEDULER_INSERT_BUTTON_LABEL: 'Insertar franjas y cerrar',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_LABEL: 'Reservar y cerrar',
    SCHEDULER_BOOK_AND_NEW_BUTTON_LABEL: 'Reservar y nuevo',
    SCHEDULER_INSERT_BUTTON_TOOLTIP: 'Insertará franjas disponibles en tu correo.',
    SCHEDULER_BOOK_AND_NEW_BUTTON_TOOLTIP: 'Reserva inmediatamente y reinicia para una nueva reserva.',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_TOOLTIP: 'Reserva inmediatamente y cierra el Meeting Booker.',
    SCHEDULER_COPY_LINK_BUTTON_LABEL: 'Copiar enlace y cerrar',
    SCHEDULER_COPY_LINK_BUTTON_TOOLTIP: 'Copiará este enlace de reserva, que puedes pegar en un correo.',
    SCHEDULER_BUTTON_PREVIOUS_WEEK: 'Semana anterior',
    SCHEDULER_BUTTON_NEXT_WEEK: 'Semana siguiente',
    SCHEDULER_BUTTON_THIS_WEEK: 'Esta semana',
    SCHEDULER_BUTTON_TODAY: 'hoy',
    SCHEDULER_ERROR: 'Error',
    INTERNAL_SERVER_ERROR: 'Error interno del servidor',
    INTERNAL_SERVER_ERROR_ALERT: 'La apertura en BLANCO se insertará en la invitación.',
    SCHEDULER_CREATE_BOOKING_PAGE_ERROR: 'Error en la solicitud CreateBookingPage. Inténtalo de nuevo más tarde',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR: 'Mejora tu plan, has alcanzado el límite.',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK: 'Explorar planes',
    SCHEDULER_MEMBERS_ERROR: 'Error en la solicitud de miembros. Inténtalo de nuevo más tarde',
    SCHEDULER_TEMPLATE_ERROR: 'Error en la solicitud de plantillas. Inténtalo de nuevo más tarde',
    GET_USER_LOGIN_ERROR_MESSAGE: 'No existe cuenta con ese correo',
    GET_USER_AUTH_ERROR_MESSAGE: 'Error en la solicitud de inicio de sesión',
    GET_USER_LOGOUT_ERROR_MESSAGE: 'Error en la solicitud de cierre de sesión',
    DELETE_USER_SUCCESS_MESSAGE: 'Error en la solicitud de autenticación',
    DELETE_USER_ERROR_MESSAGE: 'Error en la solicitud de eliminación de usuario',
    CHOOSE_AN_ACCOUNT_ERROR_TOAST: 'Error al elegir una cuenta',
    GET_MAIN_DATA_ERROR_MESSAGE: 'Error en la solicitud de autenticación',
    ROLE_DEACTIVATED_ERROR_MESSAGE: 'El rol ha sido desactivado. Contacta a tu administrador de Omnito.',
    USER_DEACTIVATED_ERROR_MESSAGE: 'El usuario ha sido desactivado. Contacta a tu administrador de Omnito.',
    TRIAL_LIMIT_ERROR_MESSAGE: 'Has superado el límite de 40 elementos en la versión de prueba',
    ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE: 'Ya existe otra cuenta asociada a este correo',
    DELETE_ROLE_ASSIGNED_ERROR_MESSAGE: 'No se puede eliminar. Hay usuarios asignados a este rol.',
    INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE: 'Clave de API de Google inválida o servicios requeridos no habilitados.',
    IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE: 'Error en la importación: Límite de 100 ubicaciones superado. Divide tu archivo.',
    PRICING_TIER_ACCESS_EXCEPTION_MESSAGE: 'Mejora tu plan de suscripción para acceder a esta función.',
    RESEND_USER_INVITE_ERROR_MESSAGE: 'Ya existe un registro de administrador con este correo en esta organización',
    ACTIVE_TAB_SIDEBAR_LICENSE_ERROR: 'Tu licencia ha expirado. Revisa tu suscripción.',
    PLEASE_WAIT_AND_TRY_AGAIN: 'Por favor espera e inténtalo de nuevo',
    FAILED_TO_LOAD_SCHEDULER_DATA: 'Error al cargar datos del programador...',
    MEETING_BOOKER_INSTALLED: 'Meeting Booker está instalado.',
    TRY_AGAIN: 'Intenta de nuevo',
    SPOTS_WIDGET_CLICK_HERE: 'Haz clic aquí',
    SPOTS_WIDGET_VIEW_MORE_OPTIONS: 'para ver más opciones',
    SPOTS_WIDGET_SELECT_TIME_SLOT: 'para seleccionar franja disponible',
    SCHEDULER_COPY_LINK: 'Copiar enlace',
    SCHEDULER_ADD_INVITEE: 'Agregar invitado',
    SCHEDULER_ADD_ATTENDEE: 'Agregar asistente',
    SEARCH_ATTENDEE_PLACEHOLDER: 'Buscar o escribir para añadir asistente',
    SEARCH_HOST_PLACEHOLDER: 'Buscar o escribir para seleccionar anfitrión',
    SHOW_WEEKENDS: 'Mostrar fines de semana',
    INVITEE_AMD_ATTENDEES: 'Invitado y asistentes',
    SCHEDULER_BOOKING_TOOLS: 'Herramientas de reservas',
    SCHEDULER_USER_SETTINGS: 'Configuración de usuario',
    SCHEDULER_ALL_PERSONAL_LINKS: 'Todos los enlaces personales',
    SCHEDULER_TOOLS: 'Herramientas',
    SCHEDULER_TEMPLATES: 'Plantillas',
    SCHEDULER_TOOLS_AVAILABILITY: 'Disponibilidad',
    SCHEDULER_TOOLS_INTEGRATE: 'Integraciones',
    SCHEDULER_TOOLS_BOOKING_PAGES: 'Tipos de reunión',
    SCHEDULER_TOOLS_MY_BOOKING_PAGES: 'Mis tipos de reunión',
    SCHEDULER_TOOLS_SHARED_BOOKING_PAGES: 'Tipos de reunión compartidos',
    SCHEDULER_HEADER_TAB_1: 'Ofrecer horario de reserva',
    SCHEDULER_HEADER_TAB_2: 'Reunión instantánea',
    SCHEDULER_DEFAULT_INVITEE_NAME_LABEL: 'Nombre',
    SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL: 'Correo',
    SCHEDULER_GUIDE_TITLE: 'Bienvenido a Meeting Booker',
    SCHEDULER_ONBOARDING: 'Iniciar onboarding',
    SCHEDULER_SKIP: 'Saltar',
    SCHEDULER_GUIDE_DESCRIPTION: 'Programa reuniones fácilmente, directamente desde tu correo. Elige tu disponibilidad, inserta franjas en tu mensaje y deja que otros escojan lo que mejor les funcione.',
    SCHEDULER_GUIDE_HOW_IT_WORKS: 'Cómo funciona',
    SCHEDULER_GUIDE_STEP_1_TITLE: 'Paso 1: Inicia sesión o crea tu cuenta',
    SCHEDULER_GUIDE_STEP_1_DESCRIPTION: 'Usa tu correo para iniciar sesión o crea rápidamente una cuenta nueva para empezar con Meeting Booker.',
    SCHEDULER_GUIDE_STEP_2_TITLE: 'Paso 2: Crea un nuevo correo',
    SCHEDULER_GUIDE_STEP_2_DESCRIPTION: 'Redacta un correo y haz clic en el ícono de Meeting Booker en la barra de herramientas.',
    SCHEDULER_GUIDE_STEP_3_TITLE: 'Paso 3: Configura tu reunión',
    SCHEDULER_GUIDE_STEP_3_DESCRIPTION: 'Elige duración, tipo de reunión, franjas horarias, invitados y añade una nota — todo sincronizado con tu calendario.',
    SCHEDULER_GUIDE_STEP_4_TITLE: 'Paso 4: Inserta franjas en tu correo',
    SCHEDULER_GUIDE_STEP_4_DESCRIPTION: 'Haz clic en “Insertar franjas y cerrar” — añadiremos tu disponibilidad directamente en el mensaje. ¡Envíalo y deja que elijan!',
    SCHEDULER_GUIDE_GET_STARTED_BUTTON: 'Comenzar',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE: '¡Reunión reservada!',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX: 'Revisa tu bandeja de entrada para un correo con todos los detalles.',
    SCHEDULER_BOOKED_ERROR_MESSAGE: 'Se requiere franja horaria',
    SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT: 'Por favor selecciona una franja del calendario para reservar tu reunión.',
    CHARACTER_LIMIT_REACHED: 'Límite alcanzado',
    SCHEDULER_TIME_SLOT_TO_SHORT_TITLE: 'Selecciona una franja más larga en el calendario.',
    SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION: `Esta franja es demasiado corta. Tu reunión requiere ${ReplacesEnum_1.ReplacesDetailEnum.DURATION}.`,
    SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE: 'Zona horaria no seleccionada',
    SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION: 'Por favor selecciona una zona horaria del menú del calendario antes de insertar franjas horarias.',
    NO_ACTIVE_WORKSPACES_TITLE: 'No hay espacios de trabajo activos',
    NO_ACTIVE_WORKSPACES: 'No hay espacios de trabajo activos en este momento. Seguro se solucionará pronto—vuelve a revisar más tarde o contacta a tu administrador.',
    WEEKDAYS_ONLY: 'Solo días laborales',
    INCLUDE_WEEKENDS: 'Incluir fines de semana',
    SUCCESS: 'Éxito',
    ERROR: 'Error',
    INFO: 'Info',
    WARNING: 'Advertencia',
    CALENDAR_DISPLAY: 'Mostrar calendario',
    MY_BOOKING_PAGES: 'Mis tipos de reunión',
    SHARED_BOOKING_PAGES: 'Tipos de reunión compartidos',
    SCHEDULER_MY_MEETINGS_LABEL: 'My Meetings',
    SCHEDULER_SHARED_MEETINGS_LABEL: 'Shared with me',
    SCHEDULER_TEAM_LABEL: 'Team',
    SCHEDULER_ROUND_ROBIN_LABEL: 'Round-Robin',
    SCHEDULER_POOL_LABEL: 'Pool',
    SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS: 'El usuario no tiene los permisos necesarios',
    CORS_CONFIGURATION_REQUIRED_TITLE: 'CORS-Configuración requerida',
    CORS_CONFIGURATION_REQUIRED_TEXT: 'El acceso a la información del usuario está bloqueado por las configuraciones de CORS de Salesforce. Contacta a tu administrador de Salesforce para resolver este problema.',
    GMAIL_CONTACTS_TOOLTIP: 'Contactos de Gmail',
    OUTLOOK_CONTACTS_TOOLTIP: 'Contactos de Outlook',
    SALESFORCE_TOOLTIP: 'Salesforce',
    SALESFORCE_LEAD_TOOLTIP: 'Lead',
    SALESFORCE_CONTACT_TOOLTIP: 'Contact',
    SALESFORCE_PERSON_ACCOUNT_TOOLTIP: 'Person Account',
    SALESFORCE_TEAM_TOOLTIP: 'Team',
    SALESFORCE_RESOURCE_TOOLTIP: 'Resource',
    SALESFORCE_BUCKET_TOOLTIP: 'Bucket',
    SALESFORCE_USER_TOOLTIP: 'User',
    HUBSPOT_TOOLTIP: 'HubSpot',
    SUMO_FOR_SALESFORCE_CEP_TOOLTIP: 'Omnito para Salesforce (CEP)',
    SERVICE_NOW_TOOLTIP: 'ServiceNow',
    SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL: 'Período de notificación mínimo',
    SCHEDULER_DURATION_WARNING: 'Advertencia: La duración total es menor que la de los servicios seleccionados.',
    SCHEDULER_HOST_LIMIT_WARNING: 'El anfitrión seleccionado ha superado su límite personal de citas para el tipo de cita seleccionado.',
    SCHEDULER_BUSY: 'Ocupado',
    // Login
    LOGIN_OR: 'o',
    LOGIN_EMAIL_PLACEHOLDER: 'Introduce tu correo electrónico',
    LOGIN_CONTINUE: 'Continuar',
    LOGIN_BACK: 'Atrás',
    LOGIN_PASSWORD_LABEL: 'Contraseña',
    LOGIN_BUTTON: 'Iniciar sesión',
    LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
    LOGIN_SEND_RECOVERY_EMAIL: 'Enviar correo de recuperación',
    FORGOT_PASSWORD_SUCCESS_MESSAGE: '¡Correo de recuperación enviado! Revisa tu bandeja de entrada para un enlace para restablecer tu contraseña.',
    LOGIN_INVALID_EMAIL: 'Por favor, introduce un correo electrónico válido',
    LOGIN_INVALID_PASSWORD: 'Por favor, introduce tu contraseña',
    LOGIN_NO_ACCOUNT: 'No se encontró cuenta con este correo.',
    // MFA (TOTP)
    MFA_TITLE: 'Autenticación de dos factores',
    MFA_SUBTITLE: 'Ingresa el código de 6 dígitos de tu aplicación de autenticación.',
    MFA_VERIFY: 'Verificar',
    MFA_SAVE_THIS_DEVICE: 'Guardar este dispositivo',
    MFA_INCORRECT_CODE: 'Código incorrecto. Por favor, intenta nuevamente.',
});
